<template>
  <!-- 简单使用 -->
  <div v-if="content" class="article-content">
    <div class="article-content-row title">
      <el-button class="btn-edit" size="small" v-if="store.sig" @click="handleEdit(id)">编辑</el-button>
      <h2>
        <Icon v-if="privacy" style="margin-left: 5px" type="ios-unlocked-outline"></Icon>
        <Icon v-if="isTop" style="margin-right: 5px; color: orange" type="flag"></Icon>
        {{ title }}
      </h2>
    </div>
    <div class="article-content-row content">
      <!-- 旧版使用quill编辑器的显示 -->
      <div v-if="isOld" class="ql-container ql-snow content">
        <div class="ql-editor" data-gramm="false" contenteditable="false" data-placeholder="" v-html="content"></div>
      </div>

      <!-- 新版使用tinymce编辑器的显示 -->
      <div v-else class="mce-content-body preview">
        <div v-html="content"></div>
      </div>
    </div>
    <div class="article-content-row" style="text-align: right">
      <span>创建时间：{{ created_at }}</span>
    </div>
    <el-backtop target=".article-content" :bottom="100"></el-backtop>
  </div>
</template>

<script setup>
  import { ref, watch, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { articleApi } from '../api/index.js';
  import dayjs from 'dayjs';
  // require styles
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import Prism from 'prismjs'; //导入代码高亮插件的core（里面提供了其他官方插件及代码高亮样式主题，你只需要引入即可）
  import 'prismjs/components/prism-bash.min.js';
  import 'prismjs/components/prism-json.min.js';
  import 'prismjs/components/prism-sql.min.js';
  import '../../public/tinymce/custom-content.css';
  import 'prism-themes/themes/prism-one-dark.min.css'; //引入代码高亮主题（这个去node_modules的安装prismjs中找到想使用的主题即可）
  // import 'prismjs/themes/prism-tomorrow.min.css'; //引入代码高亮主题（这个去node_modules的安装prismjs中找到想使用的主题即可）

  import { useUserStore } from '@/stores/user';

  const store = useUserStore();
  const $router = useRouter();

  const id = ref('');
  const title = ref('');
  const content = ref('');
  const privacy = ref(false);
  const isTop = ref(false);
  const isOld = ref(false);
  const created_at = ref('');

  const reset = () => {
    title.value = '';
    title.value = '';
    content.value = '';
    privacy.value = false;
    isTop.value = false;
    isOld.value = false;
  };

  const handleEdit = id => {
    window.sessionStorage.setItem('before_edit_href', window.location.href);
    $router.push({ path: `/admin/noteedit/${id}` });
  };

  const fetchData = async () => {
    const articleId = id.value;
    // console.log('articleId:', articleId);
    if (!articleId) {
      reset();
      return;
    }
    const result = await articleApi.findById(articleId);
    // console.log(result);
    if (result?.errcode === 0) {
      title.value = result.data.title;
      content.value = result.data.content;
      privacy.value = !!result.data.privacy;
      isTop.value = !!result.data.isTop;
      isOld.value = !!result.data.isOld;
      created_at.value = dayjs(result.data.createdAt).format('YYYY-MM-DD hh:mm');

      if (!isOld.value) {
        setTimeout(() => {
          Prism.highlightAll(); // 全局代码高亮
        }, 10);
      }
    } else {
      reset();
    }
  };

  // 监听当前路由
  watch(
    () => $router.currentRoute.value,
    newValue => {
      // console.log('newValue', newValue);
      if (id.value !== newValue.params.id) {
        id.value = newValue.params.id;
        fetchData();
      }
    },
    { immediate: true }
  );

  onMounted(async () => {
    const routVal = $router.currentRoute.value;
    // console.log('routVal', routVal);
    if (id.value !== routVal.params.id) {
      id.value = routVal.params.id;
      fetchData();
    }
  });
</script>
<style lang="less" scoped>
  .article-content {
    height: calc(100% - 55px);
    overflow: auto;
    text-align: left;
    background-color: #fff;
    padding: 0 20px 40px 10px;
    margin: 0 auto;

    .btn-edit {
      margin-right: 10px;
    }

    .article-content-row {
      display: block;
      padding: 10px 15px 0px 15px;
    }

    .article-content-row.title {
      display: flex;
      flex-direction: row;
      align-items: center;

      h2 {
        flex: 1;
      }
    }
    .article-content-row .content {
      border: 1px solid #eee;
      border-radius: 5px;
    }

    .article-content-row.summary fieldset {
      border: 1px solid #eee;
      border-radius: 5px;
      color: #777;
      font-weight: bold;
    }

    .article-content-row.summary p {
      padding: 5px 10px 10px 10px;
    }
  }
</style>
